<template lang="pug">
	.content-static-pages
		.inside.resource-links
			h3
				a(href='http://www.nfrc.org/certified-products-directory/' target='_blank') Fenestration Ratings:
					br
					span.sub-blue: | http://www.nfrc.org/certified-products-directory/
					br
			h3
				a(href='https://coolroofs.org/directory' target='_blank') Cool Roof Ratings:
					br
					span.sub-blue: | https://coolroofs.org/directory
					br
			h3
				a(href='https://www.ahridirectory.org/Search/SearchHome' target='_blank') HVAC and Water Heater	Efficiencies:
					br
					span.sub-blue: | https://www.ahridirectory.org/Search/SearchHome
					br
			h3
				a(href='https://cacertappliances.energy.ca.gov/Pages/ApplicanceSearch.aspx' target='_blank') California Certified Equipment Search:
					br
					span.sub-blue: | https://cacertappliances.energy.ca.gov/Pages/ApplicanceSearch.aspx
					br
			h3
				a(href='https://www.energy.ca.gov/HERS/providers_2016standards.html' target='_blank') HERS Inspections:
					br
					span.sub-blue: | https://www.energy.ca.gov/HERS/providers_2016standards.html
					br
			h3
				a(href='https://www.energy.ca.gov/title24/attcp/providers.html' target='_blank') Nonresidential Acceptance Testing:
					br
					span.sub-blue: | https://www.energy.ca.gov/title24/attcp/providers.html
					br
			h3
				a(href='https://www.energy.ca.gov/title24/orc/' target='_blank') California Energy Commission´s Training and Resource Center:
					br
					span.sub-blue: | https://www.energy.ca.gov/title24/orc/
					br
			h3
				a(href="/static/pdf/2016-MF1R.pdf" target='_blank') California Residential Mandatory Measures Summary (pdf)
					br
				a(href="https://www.energy.ca.gov/newnav/form_links.html" target='_blank')
					span.sub-blue: | More info: https://www.energy.ca.gov/newnav/form_links.html
</template>
<script>
export default {
	name: 'resource-links'
}
</script>

<style lang="less" scoped>
@import '~Css/responsive.less';
	.sub-blue{
		color: #0066ff;
		font-size: .7em;
		word-break: break-all;
		// border-bottom: 1px solid blue;
	}
	.resource-links{
		// border: 1px solid red;
		width: 90%;
	}
</style>



// WEBPACK FOOTER //
// src/components/resources/content-resource-links.vue